module.exports = __webpack_public_path__ + "img/752.b3598bf5.jpg";